import React from "react";
import { Reveal, HotmartButton, ReassuranceRow } from "./common";
import { PRICE } from "@/lib/site";

export const FinalCta = () => {
  return (
    <section id="comprar" className="px-4 pb-16 sm:px-6">
      <div className="mx-auto w-full max-w-5xl">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-[linear-gradient(135deg,rgba(168,216,240,0.45),rgba(253,230,138,0.4),rgba(168,230,207,0.45))] p-8 text-center sm:p-14">
            <div className="relative">
              <h2 className="mx-auto max-w-2xl font-heading text-3xl font-extrabold leading-tight text-[hsl(var(--brand-ink))] sm:text-4xl">
                Colorea las promesas de Dios junto a tu hijo
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-base text-[hsl(var(--brand-ink))]/80 sm:text-lg">
                Empieza hoy este momento inolvidable por solo{" "}
                <strong className="text-[hsl(var(--brand-coral))]">${PRICE.offer} MXN</strong>{" "}
                <span className="text-muted-foreground line-through">${PRICE.normal} MXN</span>.
              </p>
              <div className="mt-8 flex justify-center">
                <HotmartButton testId="final-primary-cta-button" variant="big">
                  Sí, quiero el ebook para mi hijo
                </HotmartButton>
              </div>
              <ReassuranceRow className="mt-5 justify-center text-[hsl(var(--brand-ink))]/70" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
